import type { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config'
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { ComputedRef } from 'vue'
import { computed, getCurrentInstance } from 'vue'
import { CONFIG_CONSTS } from '../store/config/config.consts'
import { useToolingRestricted } from './use-tooling-restricted'
import { mapGetters } from './utils'

interface RankableFieldConfig {
  id: string
  name: string
  isCategory?: boolean
}

interface InstanceComposable {
  rankableFieldConfigs: ComputedRef<Array<RankableFieldConfig>>
  instanceConfig: ComputedRef<Instance>
}

export function useInstance(): InstanceComposable {
  const ctx = getCurrentInstance()

  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }

  const { isRestricted } = useToolingRestricted()

  const { instanceConfig } = mapGetters<Instance>(ctx.proxy.$store, CONFIG_CONSTS.moduleName, {
    instanceConfig: CONFIG_CONSTS.getters.currentInstance,
  })

  const rankableFieldConfigs = computed((): Array<RankableFieldConfig> => {
    return (
      instanceConfig.value.catalog?.fields
        .filter((fieldConfig: CatalogFieldConfig) => fieldConfig.rankable)
        .filter(
          (fieldConfig: CatalogFieldConfig) => !isRestricted(fieldConfig.restricted?.role ?? []),
        )
        .map((fieldConfig: CatalogFieldConfig) => ({
          id: fieldConfig.id,
          name: fieldConfig.prettyName || fieldConfig.id,
          isCategory: fieldConfig.isCategory,
        })) ?? []
    )
  })

  return {
    rankableFieldConfigs,
    instanceConfig,
  }
}
